// src/features/leases/todayLineStyle.js
//
// Shared Today-marker line style constants.
// Used by both LeaseTimeline (CSS div) and PortfolioGantt (SVG <line>)
// so the two surfaces stay in sync without duplicate inline literals.

import { T } from "../../app/tokens.js";

export const TODAY_LINE_COLOR = T.blue;
export const TODAY_LINE_WIDTH = 2;
export const TODAY_LINE_DASH  = "4 3";
